<template>
	<div>
		<Tou></Tou>
		<div class="w1500 playDate">
			<div class="pt-34 pb-28">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="tline" :to="{ path: '/' }">Home</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/LearningLab' , query: { zinews:1 }}">Learning Lab</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/video' }">video</el-breadcrumb-item>
					<el-breadcrumb-item>{{shu.title}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="bj-0 pt-42  pb-66  mb-73 br-10 paly-detailes">
				<div class="mr-51 ml-42 br-10 mb-55 paly-detailesxq"
					v-if="xuanvideo>=0 && shu.videos && shu.videos[xuanvideo].url"
					style="position: relative;overflow: hidden;" v-html="formattedUrl" ref="iframeContainer">
				</div>
				<div class="mr-51 ml-42 tit-24 ys-33 B-500 mb-10 montserMedium">{{ shu.title }}</div>
				<el-divider class="videodivder"></el-divider>
				<!--  -->
				<div class="mt-74">
					<div class="video-carousel" style="position: relative;">
						<div class="swiper-container swiper-six">
							<div class="swiper-wrapper">
								<div v-for="(video, index) in shu.videos" :key="index"
									class="swiper-slide videoswiperslides">
									<div class="video-group">
										<div class="video-item " @click="videoxuan(index)"
											:class="xuanvideo == index ? 'vactive' : ''">
											<div style="position: relative;">
												<img :src="video.image"
													class="video-image mt-10 br-8">
												<div class="video-jiaobiao">
													<span class="ys-0 tit-13">{{ video.videoTime }} </span>
												</div>
											</div>
											<div class="video-info mt-16 pl-17 pr-12 ys-33 pb-15 montserLight">
												<p class="tit-16 shengluhao2">{{ video.title }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="swiper-button-prev swjt" style="left: -1.8%;"><i class="el-icon-arrow-left"></i>
						</div>
						<div class="swiper-button-next swjt" style="right: -1.8%;"><i class="el-icon-arrow-right"></i>
						</div>

					</div>
				</div>
			</div>

			<div class="conInfo conInfoOne">
				<div class="flex j-between mb-20 carousel-swiper">
					<div class="tit-34 B-400 ys-33 montserRegular" v-if="relatedProductlie.length>0">
						<!-- Related Products -->
						{{gudingziduan.resource.videoRelatedProducts}}
					</div>
					<div class="controls">
						<!-- <div class="swiper-button-prev swjt"><button
								class="mr-9 el-icon-back contanniu tit-20"></button>
						</div>
						<div class="swiper-button-next swjt"><button class="el-icon-right contanniu tit-20"></button>
						</div> -->
					</div>
				</div>
				<div class="related-products">
					<div class="carousel">
						<div class="swiper-container swiper-container1">
							<div class="swiper-wrapper">
								<div v-for="(product, index) in relatedProductlie" :key="index"
									class="swiper-slide videoswiperslides2"
									@click="tiaoqitaye(product.id)">
									<div style="display: block; " class="imgBox">
										<img style="display: block;height: 3.1rem; " class="product-image w100"
											:src="product.img" />
									</div>
									<div class="bj-0"
										style="border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
										<div class="tit-20 ys-33 pt-30 B-300 pl-16">{{ product.name }}</div>
										<div class="pl-16 tit-15 pt-22 z-b6 pb-26 time">{{ product.remark }}</div>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>

			<div class="conInfo conInfoTwo">
				<div class="flex j-between mb-20 carousel-swiper" v-if="popularSolutionlie.length>0">
					<div class="tit-34 B-400 ys-33 montserRegular" >
						<!-- Popular Solutions -->
						{{gudingziduan.resource.videoPopularSolutions}}

					</div>
					<div class="controls">
						<div class="swiper-button-prev swjt"><button
								class="mr-9 el-icon-back contanniu tit-20"></button>
						</div>
						<div class="swiper-button-next swjt"><button class="el-icon-right contanniu tit-20"></button>
						</div>
					</div>
				</div>
				<div class="related-products">
					<div class="carousel">
						<div class="swiper-container swiper-container2">
							<div class="swiper-wrapper">
								<div v-for="(product, index) in popularSolutionlie" :key="index"
									class="swiper-slide videoswiperslides2"
									@click="tiaoqitaye(product.id)">
									<div style="display: block; " class="imgBox">
										<img style="display: block; height: 3.1rem;" class="product-image w100"
											:src="product.image" />
									</div>
									<div class="bj-0"
										style="border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;">
										<div class="tit-20 ys-33 pt-30 B-300 pl-16">{{ product.title }}</div>
										<div class="pl-16 tit-15 pt-22 z-b6 pb-26 time">{{ product.createTime }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from '../../../zuzuzu/touss2.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import {
		Blogs
	} from '@/api/blog.js';
	import {
		Playlistxq,
		Playlist
	} from '@/api/resource.js';
	import Swiper from 'swiper'; // 注意引入的是Swiper
	import 'swiper/css/swiper.min.css' // 注意这里的引入

	export default {
		data() {
			return {
				swiper0: null,
				swiper1: null,
				swiper2: null,
				shu: {
					url: 'https://goodwe.hnydl.com.cn/gongyong/shangchuan/yinpin/33/2024/11/QW29t395sxilHdiF4868eVh6DH8XO9.mp4',
					image: "require('@/assets/pc/group/AI.png')",
					title: 'GoodWe Single Phase Storage Inverter ES Uniq - Unboxing and Installation'
				},
				videos: [],
				products: [],
				boindex: true,
				currentIndex: 0,
				currentIndex2: 0,
				currentIndex3: 0,
				visibleItems: 3,
				xuanvideo: 0,
				plid: 0,
				xiabiao: '',
				relatedProductlie: [],
				popularSolutionlie: [],
				gudingziduan: {}
			}
		},
		components: {
			Tou,
			Foot
		},
		computed: {
			formattedUrl() {
				if (this.shu.videos[this.xuanvideo] && this.shu.videos[this.xuanvideo].url) {
					const match = this.shu.videos[this.xuanvideo].url.match(/src="([^"]+)"/);
					if (match) {
						let src = match[1];
						// 判断src中是否已有参数
						if (src.includes('?')) {
							src += '&autoplay=1&mute=1';
						} else {
							src += '?autoplay=1&mute=1';
						}
						// 替换src属性值
						this.shu.videos[this.xuanvideo].url = this.shu.videos[this.xuanvideo].url.replace(match[1], src);
					}

					return this.shu.videos[this.xuanvideo].url.replace(/<iframe\s+/,
						'<iframe style="width:100% !important;" allowfullscreen mute=1 allow=autoplay  autoplay=1 ');
				}
			}
		},
		mounted() {
			this.getSwiper()
		},
		watch: {
			'$store.state.cunyuanyan': {
				handler(newValue, oldValue) {
					// console.log('语言已更新:', newValue);
					this.gudingziduan = this.$store.state.cunyuanyan
					// console.log(this.gudingziduan,'video')
				},
				deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
			}
		},
		created() {
			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
			this.gudingziduan = this.$store.state.cunyuanyan
			this.plid = this.$route.params.id;
			this.xiabiao = this.$route.query.xiabiao;
			if (this.xiabiao) {
				this.xuanvideo = this.xiabiao
			}
			Playlistxq(this.plid).then(shu => {
				this.shu = {};
				this.shu = shu.data
				this.relatedProductlie = shu.data.goods
			})
			// Playlist({ "pageNum": 0,"pageSize":9,"language":'',"country":'','popularSolution':true}).then(shu=>{
			// 	this.popularSolutionlie=shu.data.content
			// })
			Blogs({
				"available": true,
				'pageNum': 0,
				'pageSize': 10,
				"way": '',
				'popularSolution': true
			}).then(shu => {
				this.popularSolutionlie = shu.data.content
			})
		},
		methods: {
			tiaoqitaye(e) {
				// var urls = 'https://community.goodwe.com/' + e
				// window.open(urls);
				if(isExternal) {
					window.open('https://community.goodwe.com/'+id);
				} else {
					this.$router.push({
						name: 'video-details',
						params: { id: id }
					});
				}
			},
			getSwiper() {
				this.swiper0 = new Swiper(".swiper-six", {
					loop: false,
					autoplay: false,
					slidesPerView: 6, // 一组三个
					spaceBetween: 0, // 间隔
					// 如果需要前进后退按钮
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					// 窗口变化,重新init,针对F11全屏和放大缩小,必须加
					observer: true,
					observeParents: true,

					breakpoints: {
						320: {
							slidesPerView: 2,
							spaceBetween: 10,
						},
						768: {
							slidesPerView: 4,
							spaceBetween: 20,
						},
						1280: {
							slidesPerView: 6,
							spaceBetween: 0,
						}
					}
				})


				this.swiper = new Swiper(".swiper-container1", {
					loop: true,
					autoplay: false,
					slidesPerView: 3, // 一组三个
					spaceBetween: 20, // 间隔
					// 如果需要前进后退按钮
					navigation: {
						nextEl: '.conInfoOne .swiper-button-next',
						prevEl: '.conInfoOne .swiper-button-prev',
					},
					// 窗口变化,重新init,针对F11全屏和放大缩小,必须加
					observer: true,
					observeParents: true,

					breakpoints: {
						320: { //当屏幕宽度大于等于320
							slidesPerView: 2, // 一组三个
							spaceBetween: 20, // 间隔
						},
						768: { //当屏幕宽度大于等于1280
							slidesPerView: 3, // 一组三个
							spaceBetween: 20, // 间隔
						}
					}
				})

				this.swiper2 = new Swiper(".swiper-container2", {
					loop: true,
					autoplay: false,
					slidesPerView: 3, // 一组三个
					spaceBetween: 20, // 间隔
					// 如果需要前进后退按钮
					navigation: {
						nextEl: '.conInfoTwo .swiper-button-next',
						prevEl: '.conInfoTwo .swiper-button-prev',
					},
					// 窗口变化,重新init,针对F11全屏和放大缩小,必须加
					observer: true,
					observeParents: true,
					breakpoints: {
						320: { //当屏幕宽度大于等于320
							slidesPerView: 2, // 一组三个
							spaceBetween: 20, // 间隔
						},
						768: { //当屏幕宽度大于等于1280
							slidesPerView: 3, // 一组三个
							spaceBetween: 20, // 间隔
						}
					}
				})
			},

			bofan() {
				this.boindex = false
				const video = this.$refs.videos
				video.play()
			},
			videoxuan(e) {
				const video = this.$refs.videos
				this.boindex = true
				this.xuanvideo = e
				// video.pause();
				// video.load();
			},
			setDisplayedVideos() {
				const start = this.currentIndex;
				const end = start + 6;
				this.displayedVideos = this.videos.slice(start, end);
			},

		},
	}
</script>

<style lang="scss" scoped>
	.z-b6 {
		color: #B6B6B6;
	}

	.videodivder {
		margin-bottom: 0;
	}

	.palyxqirrame {
		width: 100%;
		/* 宽度填充 100% */
		max-width: 740px;
		/* 最大宽度 */
		height: 314px;
		/* 固定高度 */
		border: none;
		/* 移除边框 */
	}

	.paly-detailesxq {
		iframe {
			width: 100% !important;
			// height: 314px;
		}

		img,
		image {
			width: 100%;
		}
	}

	::v-deep .paly-detailes .zhezhao {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.3);
		position: absolute;
		top: 0%;
		left: 0;
		z-index: 9;
	}

	::v-deep .paly-detailes .zhezhao-bofan {
		width: .96rem;
		height: .69rem;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 10;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.video-carousel {
		width: 100%;
		max-width: 1500px;
		/* 根据需求限制最大宽度 */
		margin: auto;

		.el-carousel__arrow {
			width: .5rem;
			height: .48rem;
			background: #eeeeee;
			border-radius: 24px;
			box-shadow: 1px 1.73px 11px 2px rgba(5, 5, 5, 0.17);
			color: #000000;
		}

		.el-carousel__arrow--left {
			left: 4px;
		}

		.el-carousel__arrow--right {
			right: 4px;
		}
	}

	.video-group {
		display: flex;
		justify-content: space-between;
		// margin:0 0.3rem 0 0.3rem;
	}

	.videoswiperslides {
		margin: 0 0rem 0 .24rem;
		width: 2.25rem !important;
	}

	.videoswiperslides2 {
		// width: 4.86rem !important;
		// margin-left:.18rem;
	}

	.video-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		padding: 0 .1rem;

		/* 每个视频项宽度，根据需要调整 */
		// margin: 0 5px;
		/* 为项之间添加间距 */
		&:hover {
			background: #F2F2F2;
		}
	}



	.vactive {
		background: #F2F2F2;
	}

	.video-image {
		width: 1.98rem;
		/* 自适应宽度 */
		height: 1.2rem;
		/* 高度自适应 */
	}

	.video-jiaobiao {
		// height: 33px;
		opacity: 0.6;
		background: #000000;
		border-radius: 3px;
		display: inline-block;
		padding: .03rem .06rem;
		position: absolute;
		right: 5px;
		bottom: 13px;

		img {
			width: .14rem !important;
			height: .12rem !important;
		}
	}

	// =======
	.related-products {
		max-width: 1500px;
		margin: auto;
		// text-align: center;
	}

	.carousel {
		overflow: hidden;
	}

	.carousel-inner {
		display: flex;
		width: 98%;
	}

	.product-item {
		// width: 4.86rem;
		min-width: calc(100% / 3);
		/* 每次显示的产品数量为3 */
		border-radius: 10px;
	}

	.product-image {
		// width: 100;
		/* 设置产品图片的高度 */
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		/* 圆角效果 */
	}

	.conInfo {
		margin-bottom: .5rem;

		.time {
			padding-top: .05rem;
			color: #b6b6b6;
		}
	}

	.contanniu {
		width: .52rem;
		height: .52rem;
		min-height: 35px;
		min-width: 35px;
		background: #ffffff;
		color: #333;
		border: none;
		border-radius: 50%;
		transition: background-color 0.3s;
	}

	.contanniu:hover {
		background-color: #FF0000;
		color: #fff;
	}

	.swiper-container .swiper-slide .imgBox {
		overflow: hidden;
	}

	.swiper-container .swiper-slide .imgBox img {
		transition: .5s;
	}

	.swiper-container .swiper-slide:hover .imgBox img {
		transform: scale(1.1);
	}

	.swiper-button-prev::after,
	.swiper-button-next::after {
		display: none;
	}

	::v-deep .carousel-swiper .swjt {
		width: auto;
		height: auto;
		margin: 0;
		position: relative;
		left: 0;
		r: 0;
		display: inline-block;
		top: auto;
	}



	.swiper-six {

		.video-item {
			width: auto;
		}
	}

	.video-carousel {
		.swjt {
			width: 0.5rem;
			height: 0.5rem;
			min-height: 35px;
			min-width: 35px;
			background: #eeeeee;
			border-radius: 50%;
			box-shadow: 0.01rem 0.02rem 0.11rem 0.02rem rgba(5, 5, 5, 0.17);
			color: #000000;
			transition: .4s;
			right: 1%;

			&.swiper-button-prev {
				left: 1%;
			}

			&:hover {
				background: #ff0000;
				color: #fff;
			}

			&:active {
				background: #ff0000;
				color: #fff;
			}
		}
	}
</style>